import { ProductBuilderMachineContext } from '../types';

type GetPanelConfigurationOptions = (
  context: ProductBuilderMachineContext,
) => string[];

export const getPanelConfigurationOptions: GetPanelConfigurationOptions = context => {
  const {
    products,
    custom: { colour },
  } = context;

  const baseProduct = products.find(product => {
    return product.tags.includes(colour);
  });
  if (!baseProduct) return [];
  const {
    metafields: { panel_configuration },
  } = baseProduct;
  return panel_configuration ? panel_configuration : [];
};
